// @core/api/endpoints/apikey/regenerate_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateAPIKeyResponse,
  RegenerateAPIKeyRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Regenerate API key
 * Creates a new API key value while preserving the key's configuration. Optionally keeps existing permissions and restrictions. The old key is immediately revoked.
 */
export async function RegenerateAPIKey(
  key_id: string,
  data: RegenerateAPIKeyRequest,
  options?: RequestOptions
): Promise<CreateAPIKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id/regenerate`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.post<CreateAPIKeyResponse>(requestPath, data, requestOptions);
}
